export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "pt": {
        "hello": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olá"])},
        "user-content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conteúdo do usuário"])},
        "access-your-account": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Acesse sua conta"])}
      }
    }
  })
}